import { LiveAnnouncer } from '@angular/cdk/a11y';
import { AfterViewInit, Component, OnInit, ViewChild } from '@angular/core';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { MatSort, MatSortModule, Sort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { HomePageAllegatiView } from 'src/app/model/home-page-allegati-view';
import { AttachmentsService } from 'src/app/services/attachments/attachments.service';

@Component({
  selector: 'app-home-page',
  templateUrl: './home-page.component.html',
  styleUrls: ['./home-page.component.scss']
})
export class HomePageComponent implements OnInit, AfterViewInit {
  constructor(private attachmentsService: AttachmentsService) {
    this.dataSource = new MatTableDataSource();
  }

  // dataSource: MatTableDataSource<HomePageAllegatiView>;
  dataSource: MatTableDataSource<any>;

  displayedColumns: string[] = [
		"descrizione",
		"azioni",
	];
  totalItems: number = 0;
	pageSize: number = 10; // Imposta la dimensione della pagina iniziale
	pageSizeOptions: number[] = [5, 10, 25, 100]; // Opzioni di dimensione pagina
  pageIndex = 0;

  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;

	currentPage: number;

  public ngAfterViewInit(): void {
    this.currentPage = 0;
		this.pageSize = 10;
	}

  public onPageChange(event: PageEvent) {
		this.currentPage = event.pageIndex;
		this.loadDatatable();
	}

  ngOnInit(): void {
    this.loadDatatable();
  }

  loadDatatable () {
      this.attachmentsService.ricercaHomePageAllegati(this.pageIndex, this.pageSize).subscribe({
      next: (response: any) => {
        this.totalItems = response.result.count;
        // for (let i = 0; i < this.totalItems - 1; i++) {
        //   let strCamelCase = response.result.listaAllegati[i].descrizione.charAt(0).toUpperCase() + response.result.listaAllegati[i].descrizione.substr(1).toLowerCase();
        //   response.result.listaAllegati[i].descrizione = strCamelCase;
        // }
        // this.dataSource = new MatTableDataSource<HomePageAllegatiView>(response.result.listaAllegati);
        this.dataSource = new MatTableDataSource(response.result.listaAllegati);
        this.dataSource.sort = this.sort;
      }
    })
  }

  downloadAllegato(id:any) {
    let data = {
      valore:id
    }
    this.attachmentsService.downloadDocumentoHomePage(data).subscribe(
      (data:any) => {
        let fileName: string = "Decreto.pdf";
        this.attachmentsService.downloadService(data, fileName);
      }
    )
  }

  onPaginateChange(event: any) {
    this.pageIndex = event.pageIndex;
    this.pageSize = event.pageSize;

    this.loadDatatable();
  }
}
